import { Action } from 'infra/types'
import { outstandingReportActions } from './outstandingReport.actions'
import { IOutstandingReportState } from './outstandingReport.types'

const INITIAL_STATE: IOutstandingReportState = {
  loaders: {
    uploadFile: false
  },
  drawers: {
    templates: false
  }
}

export const OutstandingReportReducer = (
  state: IOutstandingReportState = INITIAL_STATE,
  action: Action<any>
): IOutstandingReportState => {
  switch (action.type) {
    case outstandingReportActions.setLoader: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [action.payload.id]: action.payload.value
        }
      }
    }
    case outstandingReportActions.setDrawer: {
      return {
        ...state,
        drawers: {
          ...state.drawers,
          [action.payload.drawerName]: action.payload.status
        }
      }
    }

    default: {
      return state
    }
  }
}
